var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiredCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34,
    stroke: "#D2D5DF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7429 35.3521H43.4207V40.3863L47.7766 42.9035L46.4377 45.2243L40.7429 41.9395V35.3521ZM54.635 40.7077C54.635 44.0219 53.7079 47.2005 51.3644 49.544C49.0209 51.8875 45.8423 53.2041 42.5281 53.2041C37.5474 53.2041 33.245 50.2764 31.2277 46.0633H19.3204C18.3735 46.0633 17.4653 45.6871 16.7957 45.0176C16.1262 44.348 15.75 43.4398 15.75 42.4929V21.0704C15.75 19.0888 17.3388 17.5 19.3204 17.5H47.8837C48.8306 17.5 49.7388 17.8762 50.4084 18.5457C51.0779 19.2153 51.4541 20.1235 51.4541 21.0704V31.9602C53.6678 34.2095 54.635 37.2979 54.635 40.7077ZM30.0316 40.7077C30.0316 35.3521 32.044 31.7817 36.2164 29.0552H18.801V43.0772L30.1535 43.0772C30.1535 42.2982 30.0316 41.3146 30.0316 40.7077ZM42.5605 31.0027C40.1932 31.0027 37.2235 32.0552 35.5495 33.7292C33.2125 36.0662 32.823 38.3404 32.823 40.7077C32.823 43.075 33.602 45.8037 35.5495 47.7512C37.3424 49.544 40.1608 50.4777 42.5281 50.4777C44.8954 50.4777 47.508 49.4251 49.182 47.7512C50.856 46.0772 51.9085 43.075 51.9085 40.7077C51.9085 38.3404 50.856 35.4031 49.182 33.7292C47.508 32.0552 44.9278 31.0027 42.5605 31.0027ZM48.4948 24.6408V20.4862H18.801V24.6408L48.4948 24.6408Z",
    fill: "#0F205E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiredCard);
export default __webpack_public_path__ + "static/media/tired_card.5741d792840964064a517e6f9c8b58d6.svg";
export { ForwardRef as ReactComponent };